import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/components/HelloWorld')
    },
    // 隐私政策
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: () => import('@/views/PrivacyPolicy')
    },
    // 用户协议 
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('@/views/userAgreement')
    },
    // 免责说明 
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: () => import('@/views/disclaimer')
    },
    {
      path: '/healthDataSources',
      name: 'healthDataSources',
      component: () => import('@/views/healthDataSources')
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js